<template>
  <div>
    <TableUsers v-model="search" :users="users" />
  </div>
</template>

<script>
import TableUsers from '@/components/TableUsers'

export default {
  name: 'Users',

  data() {
    return {
      users: [],
      search: ''
    }
  },

  components: {
    TableUsers
  },

  methods: {
    async get() {
      await this.$api.get('/users')
      .then((response) => {
        this.users = response.data.users
      })
      .catch((err) => {
        this.$toastr.e(err.response.data.message)
      })
    },
  },

  created() {
    this.get()
  }
}
</script>

<style>

</style>